/**
 * Created by wwei on 2018-07-27.
 */

import React, { Component } from "react";
import { translate, Interpolate } from "react-i18next";
import QueryString from "query-string";
import { Icon } from "antd";
import { httpRequest as request } from "../../common/functions/CustomRequest.js";
import { saveGAEvent } from "../../common/functions/GAUtils.js";
import { URL } from "../../common/Constants.js";
import Loading from "../../common/components/Loading.js";

class DomainVerification extends Component {
  constructor(props) {
    super(props);
    this.state = {
      verified: undefined,
      second: 5
    };
  }

  componentDidMount() {
    const queryParams = QueryString.parse(this.props.location.search);
    const vc = queryParams.vc;
    this.verifyEmail(vc);
  }

  componentWillUnmount() {
    if (this.timerId !== null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  }

  timerId = null;
  verifyEmail = vc => {
    if (vc) {
      request("/api/domains/verifyEmail", "post", {
        emailVerificationCode: vc
      })
        .then(res => {
          this.setState({ verified: true });
          saveGAEvent("domain_management", "email_verification_pass", "pass");
          this.timerId = setInterval(() => {
            let sec = this.state.second - 1;
            this.setState({ second: sec });
            if (sec === 0) {
              clearInterval(this.timerId);
              this.timerId = null;
              this.props.history.push({ pathname: URL.LOGIN });
            }
          }, 1000);
        })
        .catch(err => {
          this.setState({ verified: false });
          console.error("Failed to verify. ", err);
          saveGAEvent("domain_management", "email_verification_fail", "fail");
        });
    } else {
      this.setState({ verified: false });
    }
  };

  render = () => {
    const { t } = this.props;
    const { verified, second } = this.state;
    return (
      <div className="pholio-main-contaner">
        <div className="pholio-header">
          <div className="logo" />
          <div className="product-name">{t("COMMON.TITLE")}</div>
        </div>
        <div className="loginPageContainer">
          <div className="loginpage">
            <div className="loginpage-center">
              <div className="loginpage-inside">
                <div className="login-area" style={{ width: 400 }}>
                  <div
                    className="login-action-area"
                    style={{
                      textAlign: "center",
                      width: 400,
                      color: "#7f7f7f"
                    }}
                  >
                    {verified === undefined ? (
                      <div>
                        <Loading />
                        <div style={{ fontSize: 20, margin: 5 }}>
                          {t("DOMAIN_MGMT.VERIFYING_EMAIL")}
                        </div>
                        <div>{t("COMMON.WAIT")}</div>
                      </div>
                    ) : verified ? (
                      <div>
                        <Icon
                          type="check-circle"
                          style={{ color: "#0277BD", fontSize: 30 }}
                        />
                        <div style={{ fontSize: 20, margin: 5 }}>
                          {t("DOMAIN_MGMT.EMAIL_VERIFIED")}
                        </div>
                        <div>
                          <Interpolate
                            i18nKey="DOMAIN_MGMT.REDIRECTING"
                            useDangerouslySetInnerHTML={true}
                            sign={<a href={URL.LOGIN}>{t("COMMON.SIGN_IN")}</a>}
                            sec={second}
                          />
                        </div>
                      </div>
                    ) : (
                      <div>
                        <Icon
                          type="warning"
                          style={{ color: "#C41C22", fontSize: 50 }}
                        />
                        <div style={{ fontSize: 20, margin: 5 }}>
                          {t("DOMAIN_MGMT.VERIFY_FAILED")}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

export default translate()(DomainVerification);



// WEBPACK FOOTER //
// ./src/tenantportal/domainMgmt/DomainVerification.js